<template>
  <div>
    <div class="dropdown w-100">
      <button class="btn btn-outline d-flex align-items-center justify-content-between w-100"
              :class="selected ? 'btn-primary' : 'btn-outline'"
              :disabled="disabled"
              data-toggle="dropdown">
        <span>{{ title }}</span>
        <i class="fas fa-caret-down"></i>
      </button>
      <div class="dropdown-menu w-100">
        <div class="tw-font-semibold px-3 pb-2">Choose Asset count</div>
        <button class="dropdown-item py-2" v-for="option in prices" :key="option.id"
                @click="selectedPriceId = option.id">
                <span class="tw-flex tw-justify-between tw-items-center tw-text-sm">
                  <span>{{ option.name }} / {{ option.interval }}</span>
                  <i class="fas fa-check-circle text-primary" :class="{'invisible': selectedPriceId !== option.id}"></i>
                </span>

        </button>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'OnboardingPriceSelectDropdown',
  props: {
    selected: {
      type: Boolean,
      required: true
    },
    prices: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    selectedPriceId: {
      get() {return this.value},
      set(selectedPriceId) { this.$emit('input', selectedPriceId)}
    }
  }
}
</script>